import React, {useState, useEffect,} from 'react';
import Api from '../../Api';
import Butao from '../../Components/Butao_list';
import TACampoNum from '../../Components/TACampoNum';
import Header from '../../Components/Header';
import { Spinner  } from "react-awesome-spinners";
import FinderSelect from 'react-finderselect';
import { Web } from '@material-ui/icons';
import Select from 'react-select';



export default ({InfIdUse, InfIdConta, IdUse, IdConta, setAddList, setUsuariosContServ, UsuariosContServ,  Dados, Avisando, Fechar, Id, setAlert, setAlertTipo, MsgDesativar}) => {

const [Titulo, setTitulo] = useState("Criar Medidas do Aluno");
const [MsgErro, setMsgErro] = useState("");
const [Loading, setLoading] = useState(false);
const [ListAluno, setListAluno] = useState([]);
const [ListTel, setListTel] = useState([]);
const [IdAluno, setIdAluno] = useState("");
const [Nome, setNome] = useState("");
const [Telefone, setTelefone] = useState("");
const [Peso, setPeso] = useState("");
const [Altura, setAltura] = useState("");
const [Ombro, setOmbro] = useState("");
const [Peitoral, setPeitoral] = useState("");
const [BracoEsq, setBracoEsq] = useState("");
const [BracoDir, setBracoDir] = useState("");
const [AnteBracoEsq, setAnteBracoEsq] = useState("");
const [AnteBracoDir, setAnteBracoDir] = useState("");
const [Cintura, setCintura] = useState("");
const [Quadril, setQuadril] = useState("");
const [PernaEsq, setPernaEsq] = useState("");
const [PernaDir, setPernaDir] = useState("");
const [PanturrilhaEsq, setPanturrilhaEsq] = useState("");
const [PanturrilhaDir, setPanturrilhaDir] = useState("");
const [IMC, setIMC] = useState("");

 useEffect(() => {
       ListAlunos();     
      }, [])


 useEffect(() => {
      CalculandoIMC()
      }, [Peso, Altura])

const CalculandoIMC = async ()=>{
  var Alt = Altura/100
     setIMC(Peso/(Alt*Alt))
   }
   
 const ListAlunos = async ()=>{
   await Api.TAListAlunosMedidas(IdConta, setListTel, setListAluno)
   }

  const criando = ()=>{

   


   
    
    if(IdAluno){
      if (navigator.onLine) {
        setMsgErro("")
        setLoading(true) 
          
        Api.TACriarMedidasAlunos(IMC, PanturrilhaDir, PanturrilhaEsq, PernaDir, PernaEsq, Quadril, Cintura, AnteBracoDir, AnteBracoEsq, BracoDir, BracoEsq, Peitoral, Ombro, Altura, Peso, IdAluno, Nome, Telefone, IdConta, InfIdUse,  IdUse,   setMsgErro, setLoading, setAlertTipo, setAlert, setAddList);
 
      } else {
        setAlert("Sem Internet");
        setAlertTipo("danger");
      }
    } else {
        setMsgErro("Escolha o aluno referente às medidas.")
    }
    
    
  
   
  }

const printValue4 = (target) => {
           
            setIdAluno(target.value) 
            setTelefone(target.label)
            setNome(target.Nome)
            
      }
  const printValue5 = (target) => {
                      
            setIdAluno(target.value) 
            setTelefone(target.Telefone)
            setNome(target.label)
    
      }
const Limpando = () => {

            setIdAluno("") 
            setTelefone("")
            setNome("")

      }
        return (
            <>
<div className="content-wrapper">
                <Header 
                Titulo={Titulo}
                Avisando={Avisando}
                Fechar={Fechar}
                />
               <section className="content">
                  <div className="container-fluid">
                    <div className="row">
                      <div className="col-12">
            
              <div className="invoice p-3 mb-3">
              {/* title row */}
              <div className="row">
                <div className="col-12">
                  <h4>
                    <i className="fas fa-clipboard" /> Medidas do Aluno 
                  </h4>
                </div>
                {/* /.col */}
              </div>
              {/* info row */}
              <div className="row invoice-info">
                <div className="col-sm-4 invoice-col">
                  <address>
                    {Loading  ?
                    <>
                      <Spinner 
                      size={64}
                      color={"#5d0bf7"}
                      sizeUnit={'px'} 
                      /><br />
                      </>
                      :
                      <>
                    <div className="col-12">
                        <Butao 
                        style={"btn .btn-sm btn-info"}
                        titulo={"Salvar"}
                        onClick={()=>criando()}
                        />  
                    </div><br />
                    
                     {MsgErro !== "" &&
                    <>
                    <div class="alert alert-danger alert-dismissible">
                  
                  <h5><i class="icon fas fa-ban"></i> Alert!</h5>
                  {MsgErro}
                </div>
                   
                    </>
                    }
                    </>
                    }
                     {ListAluno.length !== 0 &&
                      <>
                        <strong>Nome do Aluno</strong><br />
                        {Nome ?
                        <>
                        <string>{Nome}</string> 
                        <br />
                        </>
                        :
                    <Select
                        defaultValue={Nome}
                        onChange={(target) =>printValue5(target)}
                        options={ListAluno}
                        placeholder={"Escolha  o Nome "}
                      /> 
                                        
                      }
                </>
                    }
                    
                    {ListTel.length !== 0 &&
                      <>
                        <strong>Telefone do Aluno</strong><br />
                        {Telefone ?
                        <>
                        <string>{Telefone}</string> 
                        <br />
                        </>
                        :
                       
                       <Select
                        defaultValue={Telefone}
                        onChange={(target) => printValue4(target)}
                        options={ListTel}
                        placeholder={"Escolha  o Telefone"}
                      />   
                     
                      }
                    </>
                    }
                    {Nome  && 
                    <>

                    <Butao 
                    style={"btn btn-sm btn-danger"}
                    titulo={"Limpar"}
                    onClick={()=>Limpando()}
                    />
                    <br />
                    <br />
                    
                     </>

                    }
                    {/* <strong>Nome do Aluno</strong><br />
                    <string>{Nome}</string> 
                    <br />
                 
                   <strong>Telefone do Aluno</strong><br />
                  <string>{Telefone}</string>
                    <br /> */}
                  
                     <br />
                        
                        
                        
                    <strong>Peso (Kg)</strong><br />
                    <div className="input_cadatro">
                              
                           <TACampoNum 
                                type={"tel"}
                                placeholder={"0"}
                                icon={"Kg"}
                                value={Peso}
                                onChange={e=>setPeso(e.target.value)}
                                mask={"****"}
                                />
                            </div> 
                    <br />
                     
                      <strong>Altura (cm)</strong><br />
                    <div className="input_cadatro">
                              
                           <TACampoNum 
                                type={"tel"}
                                placeholder={"0"}
                                icon={"cm"}
                                value={Altura}
                                onChange={e=>setAltura(e.target.value)}
                                mask={"9999"}
                                />
                            </div> 
                    <br />
                   
                      <strong>IMC </strong><br />
                     <string>{IMC?IMC.toFixed(1):0} Kg/M<sup>2</sup></string><br />
                   
                   
                    
                   
                     
                  
                 
                     
                  </address>
                    </div>
                      <div className="col-sm-4 invoice-col">
                    <address>
                       <strong>Ombro (cm)</strong><br />
                    <div className="input_cadatro">
                              
                           <TACampoNum 
                                type={"tel"}
                                placeholder={"0"}
                                icon={"cm"}
                                value={Ombro}
                                onChange={e=>setOmbro(e.target.value)}
                                mask={"9999"}
                                />
                            </div> 
                    <br />
                     <strong>Peitoral (cm)</strong><br />
                    <div className="input_cadatro">
                              
                           <TACampoNum 
                                type={"tel"}
                                placeholder={"0"}
                                icon={"cm"}
                                value={Peitoral}
                                onChange={e=>setPeitoral(e.target.value)}
                                mask={"9999"}
                                />
                            </div> 
                    <br />
                     <strong>Braço Esquerdo (cm)</strong><br />
                    <div className="input_cadatro">
                              
                           <TACampoNum 
                                type={"tel"}
                                placeholder={"0"}
                                icon={"cm"}
                                value={BracoEsq}
                                onChange={e=>setBracoEsq(e.target.value)}
                                mask={"9999"}
                                />
                            </div> 
                    <br />
                     <strong>Braço Direito (cm)</strong><br />
                    <div className="input_cadatro">
                              
                           <TACampoNum 
                                type={"tel"}
                                placeholder={"0"}
                                icon={"cm"}
                                value={BracoDir}
                                onChange={e=>setBracoDir(e.target.value)}
                                mask={"9999"}
                                />
                            </div> 
                    <br />
                      <strong>AnteBraço Esquerdo (cm)</strong><br />
                    <div className="input_cadatro">
                              
                           <TACampoNum 
                                type={"tel"}
                                placeholder={"0"}
                                icon={"cm"}
                                value={AnteBracoEsq}
                                onChange={e=>setAnteBracoEsq(e.target.value)}
                                mask={"9999"}
                                />
                            </div> 
                    <br />
                    <strong>AnteBraço Direito (cm)</strong><br />
                    <div className="input_cadatro">
                              
                           <TACampoNum 
                                type={"tel"}
                                placeholder={"0"}
                                icon={"cm"}
                                value={AnteBracoDir}
                                onChange={e=>setAnteBracoDir(e.target.value)}
                                mask={"9999"}
                                />
                            </div> 
                    <br />
                     
                  
                     
                    
                    </address>
                   </div>
                    <div className="col-sm-4 invoice-col">
                    <address>
                       <strong>Cintura (cm)</strong><br />
                    <div className="input_cadatro">
                              
                           <TACampoNum 
                                type={"tel"}
                                placeholder={"0"}
                                icon={"cm"}
                                value={Cintura}
                                onChange={e=>setCintura(e.target.value)}
                                mask={"9999"}
                                />
                            </div> 
                    <br />
                    <strong>Quadril (cm)</strong><br />
                    <div className="input_cadatro">
                              
                           <TACampoNum 
                                type={"tel"}
                                placeholder={"0"}
                                icon={"cm"}
                                value={Quadril}
                                onChange={e=>setQuadril(e.target.value)}
                                mask={"9999"}
                                />
                            </div> 
                    <br />
                     <strong>Perna Esquerdo (cm)</strong><br />
                    <div className="input_cadatro">
                              
                           <TACampoNum 
                                type={"tel"}
                                placeholder={"0"}
                                icon={"cm"}
                                value={PernaEsq}
                                onChange={e=>setPernaEsq(e.target.value)}
                                mask={"9999"}
                                />
                            </div> 
                    <br />
                     <strong>Perna Direito (cm)</strong><br />
                    <div className="input_cadatro">
                              
                           <TACampoNum 
                                type={"tel"}
                                placeholder={"0"}
                                icon={"cm"}
                                value={PernaDir}
                                onChange={e=>setPernaDir(e.target.value)}
                                mask={"9999"}
                                />
                            </div> 
                    <br />
                      <strong>Panturrilha Esquerdo (cm)</strong><br />
                    <div className="input_cadatro">
                              
                           <TACampoNum 
                                type={"tel"}
                                placeholder={"0"}
                                icon={"cm"}
                                value={PanturrilhaEsq}
                                onChange={e=>setPanturrilhaEsq(e.target.value)}
                                mask={"9999"}
                                />
                            </div> 
                    <br />
                    <strong>Panturrilha Direito (cm)</strong><br />
                    <div className="input_cadatro">
                              
                           <TACampoNum 
                                type={"tel"}
                                placeholder={"0"}
                                icon={"cm"}
                                value={PanturrilhaDir}
                                onChange={e=>setPanturrilhaDir(e.target.value)}
                                mask={"9999"}
                                />
                            </div> 
                    <br />
                  
  
                    </address>
                   </div>
              </div>
              <div className="row no-print">
              </div>
              
            
            </div> 
            </div>
            </div>
            </div>
          </section>
  
</div>

            </>
        );
}